import { getPatientRef } from '../../../helper/getPatientRef';

const actions = {
  async reqPatientRef({ commit }, id) {
    try {
      const { data } = await getPatientRef(id);
      commit('SET_PATIENT_REF', data.ref);
    } catch (error) {
      console.error(error);
    }
  },
  setSelectedTab({ commit }, payload) {
    commit('SET_SELECTED_TAB', payload);
  },
  reconstructTab({ commit }, payload) {
    commit("RECONSTRUCT_TAB", payload);
  },
  setNavs({ commit }, payload) {
    commit("SET_NAVS", payload);
  },
  setCanManagePatientValue({ commit }, payload) {
    commit("SET_CAN_MANAGE_PATIENT", payload);
  },
}

export default actions;